import {
    app,
    Component,
    ojs,
    v,
} from "modular-openscriptjs";
import { empty, eParse } from "../../../helpers";
import { beginSuggestionRequest, isSuggestionRequestCurrent } from "../../../helpers";
import { dc } from "../../../declarations";
import SubcategoryProductsDefault from "./SubcategoryProductsDefault";
import SubcategoryProductsResult from "./SubcategoryProductsResult";
import AlgoliaSearch from "../../../classes/AlgoliaSearch";
import ViewProductCanvas from "../../Offcanvas/ViewProductCanvas";
import ViewProduct from "../../Views/ViewProduct";
import ViewProductModal from "../../Modals/ViewProductModal";

const h = app("h");

ojs(
    SubcategoryProductsDefault,
    SubcategoryProductsResult,
);

export default class SubcategoryProductsPage extends Component {

    $$app = {
        has: {
            searchCharacter: async (ed, event) => {
                const { message } = eParse(ed);
                let query = message.get("value");

                if (empty(query)) {
                    dc.searchSuggestions.value = [];
                    return;
                }

                /**
                 * @type {AlgoliaSearch}
                 */
                let client = app("AlgoliaSearch");

                const ticket = beginSuggestionRequest();
                let result = await client.getSuggestions(query);
                // The user may have navigated away while this was in flight.
                if (!isSuggestionRequestCurrent(ticket)) {
                    return;
                }

                dc.searchSuggestions.value = result;
            },
        },
    };

    render(...args) {
        return h.div(
            v(dc.searchQuery, (searchState) =>
                empty(searchState.value)
                    ? h.SubcategoryProductsDefault()
                    : h.SubcategoryProductsResult()
            ),
            ...args,
        );
    }
}

ojs(SubcategoryProductsPage);
